import { render } from "./write-to-decision-maker.vue?vue&type=template&id=9e800e36"
import script from "./write-to-decision-maker.vue?vue&type=script&lang=js"
export * from "./write-to-decision-maker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__